import React from 'react';
import './new-txt-label.m.css';

const NewTxtLabel = ({ text = 'NEW', isShape = true, apiClass = '' }) => {
  return (
    <span
      styleName={`newLabel ${!isShape ? 'noShape' : ''}`}
      className={`labelPosition ${apiClass}`}
    >
      {text}
    </span>
  );
};

export default NewTxtLabel;
